import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    width: 80,
  },
  card: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: 80,
    width: 80,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderColor: '#ebedf2',
  },
  hour: {
    color: '#b5b5c3',
  },
});
